<div id="app"><div id="navbar-router-wrapper"><app-navbar></app-navbar><router-view></router-view></div><app-footer></app-footer><toasts></toasts></div>